module.exports = __webpack_public_path__ + "static/media/oralb_step2.85ad3289.png";